// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bh-3";
export var contentContainer = "_bh-0";
export var editorContainer = "_bh-1";
export var quillInputForm = "_bh-2";
export var zoneDivider = "_bh-4";